import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Black Plus',
    description: 'Effortlessly track and manage your time with Black. Customizable reports, invoicing, and integrations make it the perfect tool for freelancers and professionals.',
    url: 'https://blackplus.com'
}
